import React, { useState } from 'react';
import { string, bool } from 'prop-types';
import { Dropdown, DropdownAnchor, DropdownContent, DropdownMenu, MenuItem } from '@fiverr-private/dropdown';
import { useEventsContext } from '../utils/events';
import { getLinks } from '../shared/links';
import ResourcesListItem from './ResourcesListItem';
import TriggerButton from './TriggerButton';

const ResourcesTab = ({ headerType = '', isTransparent = false }) => {
    const { EventsReportApiContext, eventsApi } = useEventsContext({ headerType });
    const [isOpen, setIsOpen] = useState(false);
    const links = getLinks(headerType);

    return (
        <EventsReportApiContext.Provider value={eventsApi}>
            <Dropdown onOpenChanged={setIsOpen} width="350px" borderRadius="xl">
                <DropdownAnchor>
                    <TriggerButton isTransparent={isTransparent} isOpen={isOpen} />
                </DropdownAnchor>
                <DropdownContent>
                    <DropdownMenu maxHeight="auto">
                        {links.map((link) => (
                            <MenuItem key={link.key}>
                                <ResourcesListItem link={link} headerType={headerType} />
                            </MenuItem>
                        ))}
                    </DropdownMenu>
                </DropdownContent>
            </Dropdown>
        </EventsReportApiContext.Provider>
    );
};

ResourcesTab.propTypes = {
    headerType: string,
    isTransparent: bool,
};

export default ResourcesTab;
